import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import InstitutionalRealEstateDevelopment from "./sections/InstitutionalRealEstateDevelopment";
import QuantifiableImpact from "./sections/QuantifiableImpact";
import CoreConsultingPillars from "./sections/CoreConsultingPillars";
import EngineeredForExcellence from "./sections/EngineeredForExcellence";
import CertifiedExcellence from "./sections/CertifiedExcellence";
import InitiateOptimization from "./sections/InitiateOptimization";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <InstitutionalRealEstateDevelopment />
      <QuantifiableImpact />
      <CoreConsultingPillars />
      <EngineeredForExcellence />
      <CertifiedExcellence />
      <InitiateOptimization />
      <Footer />
    </div>;
}